var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBullePenseePersonnagePc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.236,
    height: 112.543,
    viewBox: "0 0 104.236 112.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_130",
    "data-name": "Groupe 130",
    transform: "translate(-1260 -533.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_121",
    "data-name": "Groupe 121",
    transform: "translate(759.157 259.111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_360",
    "data-name": "Rectangle 360",
    width: 16.155,
    height: 32.313,
    transform: "translate(533.155 290.812)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_363",
    "data-name": "Rectangle 363",
    width: 16.159,
    height: 32.313,
    transform: "translate(516.997 290.812)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_364",
    "data-name": "Rectangle 364",
    width: 16.155,
    height: 32.313,
    transform: "translate(549.31 290.812)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_365",
    "data-name": "Rectangle 365",
    width: 32.313,
    height: 16.155,
    transform: "translate(516.997 274.657)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_366",
    "data-name": "Rectangle 366",
    width: 32.313,
    height: 16.155,
    transform: "translate(516.997 323.125)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_368",
    "data-name": "Rectangle 368",
    width: 16.155,
    height: 32.313,
    transform: "translate(500.842 290.812)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_122",
    "data-name": "Groupe 122",
    transform: "translate(831.08 226.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_120",
    "data-name": "Trac\\xE9 120",
    d: "M1730.2,1776.241V1792.4h16.155v-32.313H1730.2Z",
    transform: "translate(-1229.36 -1388.494)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_122",
    "data-name": "Trac\\xE9 122",
    d: "M1691.421,1776.241V1792.4h16.159v-32.313h-16.159Z",
    transform: "translate(-1206.738 -1388.494)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_124",
    "data-name": "Trac\\xE9 124",
    d: "M1768.973,1776.241V1792.4h16.159v-32.313h-16.159Z",
    transform: "translate(-1251.977 -1388.494)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_367",
    "data-name": "Rectangle 367",
    width: 32.313,
    height: 16.155,
    transform: "translate(484.683 355.438)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_369",
    "data-name": "Rectangle 369",
    width: 32.313,
    height: 16.155,
    transform: "translate(484.683 403.906)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_372",
    "data-name": "Rectangle 372",
    width: 16.155,
    height: 32.313,
    transform: "translate(468.529 371.593)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullePenseePersonnagePc);
export default __webpack_public_path__ + "static/media/bulle_pensee_personnage_pc.f307fd64336971e171e6f2513473ce88.svg";
export { ForwardRef as ReactComponent };